import { Ref, ref } from 'vue';
import {
  AlignLeft,
  AlignRight,
  PilcrowLeft,
  PilcrowRight,
} from 'lucide-vue-next';

export const editors = new Map();
const editorStateMap = new Map<
  string,
  {
    alignmentRef: Ref<any>;
    directionRef: Ref<any>;
    typographyRef: Ref<string>;
    activeTypo: Ref<any>;
  }
>();

export const getEditor = id => {
  return editors.get(id)?.editor || null;
};

export const isEditorRTL = id => {
  return editors.get(id)?.direction === 'rtl';
};

export const getEnables = id => {
  return editors.get(id)?.enables;
};

export const setExtensionEnabled = (id, extension, value, hideOnly = false) => {
  const editor = editors.get(id);
  if (!editor) return;

  const key = hideOnly ? `hide_${extension}` : extension;
  editor.enables[key] = value;
};

export const isEnabled = (id, extension) => {
  return (
    editors.get(id)?.enables[extension] !== false &&
    editors.get(id)?.enables[`hide_${extension}`] !== false
  );
};

export const getEditorState = (id: string) => {
  if (!editorStateMap.has(id)) {
    editorStateMap.set(id, {
      alignmentRef: ref(isEditorRTL(id) ? AlignRight : AlignLeft),
      directionRef: ref(isEditorRTL(id) ? PilcrowLeft : PilcrowRight),
      typographyRef: ref('טקסט פסקה'),
      activeTypo: ref(null),
    });
  }
  return editorStateMap.get(id)!;
};
